<template>
  <div class="layout">
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="stylus" scoped>
.layout
  height 100%
  overflow auto
</style>
